import React, { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import LoaderButton from "../components/LoaderButton";
import PageLoader from "../components/PageLoader";
import { Constants } from "../libs/Constants";
import { getList, update } from "../libs/dbFunctions";
import {
  convertToDollar,
  convertUTCDateInTimeZone,
  formatCurrency,
} from "../libs/utils";
import "./ChangeCompany.css";

export default function Reports(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [reports, setReports] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);

  useEffect(() => {
    loadReports();
  }, [props.isAuthenticated, props.userObj, props.location]);

  useEffect(() => {
    if (reports && reports.length > 0) {
      loadDisplayItems();
    }
  }, [reports]);

  function displayDeptHeader() {
    return departmentList.map((dept) => {
      return <th key={dept}>{dept}</th>;
    });
  }
  async function loadReports() {
    // make API call to get reports
    setIsLoading(true);
    try {
      let reports = await getList(
        Constants.dbTypes.REPORT,
        props.activeCompany
      );
      setReports(reports);
    } catch (e) {
      toast.error(e);
    }
    setIsLoading(false);
  }
  function loadDisplayItems() {
    let cols = [];
    let deptList = [];
    let deptObjList = [];
    reports.map((report) => {
      if ("terminate" in report) {
        report.expense += report.terminate;
      }

      if ("withdraw" in report) {
        report.expense += report.withdraw;
      }
      cols = Object.keys(report);
      for (let c of cols) {
        if (c.startsWith("d_")) {
          deptList.push(c.replace("d_", ""));
          deptObjList.push({
            name: c.replace("d_", ""),
            amount: convertToDollar(report[c]),
          });
        }
      }
      deptObjList = [];
    });
    //remove duplicates from deptList
    let uniqDept = deptList.reduce((a, b) => {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);
    setDepartmentList(uniqDept);
  }
  function renderHeader() {
    return (
      <thead key="header">
        <tr key="headerrow">
          <th>Period</th>
          <th>Company Expense</th>
          {displayDeptHeader()}

          <th>Action </th>
        </tr>
      </thead>
    );
  }
  function displayDeptamounts(row) {
    return departmentList.map((d, index) => {
      if (`d_${d}` in row) {
        return (
          <td key={index}>
            {" "}
            {formatCurrency(convertToDollar(row[`d_${d}`]))}{" "}
          </td>
        );
      } else {
        return <td key={index}>$0.00</td>;
      }
    });
  }
  async function startRerun(e) {
    try {
      let obj = {
        month: e.period,
        activeCompanyId: props.activeCompany.id,
      };
      console.log("obj", obj);
      await update(Constants.dbTypes.REPORT, obj);
      toast.success(
        "Rerun started successfully. It will take few minutes to finish it"
      );
      props.history.push("/");
    } catch (e) {
      toast.error(e);
    }
  }
  function renderList() {
    if (reports && reports.length > 0) {
      return reports.map((item) => {
        return (
          <tr key={item.period}>
            <td>
              {" "}
              {convertUTCDateInTimeZone(
                item.period,

                props.activeCompany.timezone
              ).format("MM-YYYY")}
            </td>

            <td>{formatCurrency(convertToDollar(item.expense))} </td>

            {displayDeptamounts(item)}
            <td>
              <LoaderButton
                size="sm"
                className="mt3"
                id={item.month}
                block
                variant="primary"
                onClick={() => startRerun(item)}
                disabled={item.state === "valid"}
                isLoading={isLoading}
              >
                Rerun
              </LoaderButton>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          {" "}
          <td colSpan="4">No reports found</td>
        </tr>
      );
    }
  }
  return (
    <PageLoader isActive={isLoading} individual={false}>
      <div className="container p5">
        <Card>
          <Card.Body>
            <Card.Title as="h2" className="companies-drop-down mb10">
              {props.activeCompany.name} - Reports
            </Card.Title>

            <div className="container p4">
              <Card>
                <Card.Body>
                  {reports && (
                    <Table striped bordered hover responsive size="sm">
                      {renderHeader()}
                      <tbody>{renderList()}</tbody>
                    </Table>
                  )}
                </Card.Body>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </PageLoader>
  );
}
